import { RouteType } from 'types/RouteType'; // Adjust the import path as necessary
import databaseManagerRoute from './DatabaseManager/databaseManager.Route';
import systemHealthRoute from './SystemHealth/systemHealth.Route';
import dataIntegrityRoute from './DataIntegrity/dataIntegrity.Route';
import auditLogRoute from './AuditLog/auditLog.Route';
import integrationErrorsRoute from './IntegrationErrors/integrationErrors.Route';
import securitySettingsRoute from './securitySettings.Route';
import apiKeysRoute from './ApiKeys/apiKeys.Route';
import dataExportRoute from './DataExport/dataExport.Route';
import emailRoute from './Email/email.Route';
import trackerImportRoute from './TrackerImport/trackerImport.Route';

const adminRoutesList: RouteType[] = [
  databaseManagerRoute,
  systemHealthRoute,
  dataIntegrityRoute,
  auditLogRoute,
  integrationErrorsRoute,
  securitySettingsRoute,
  apiKeysRoute,
  dataExportRoute,
  // Admin → Email: named by the email.sendgrid readiness card's remediation.
  emailRoute,
  // Admin → Import trackers: Blake's AR / contracts / onboarding exports (#3075 / #2663).
  trackerImportRoute,
];

export default adminRoutesList;
